import {
    FETCH_REPORTING_REQUEST,
    FETCH_REPORTING_SUCCESS,
    FETCH_REPORTING_FAILURE,
    CLEAR_REPORTING_DATA,

  } from '../actions/reportingActions';
  
  const initialState = {
    reportingData: [],
    reportingTotal: null,
    loading: false,
    error: null,
  };
  
  const reportingReducer = (state = initialState, action) => {
    //console.log('action>>>>>', action);
    switch (action.type) {
      case FETCH_REPORTING_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_REPORTING_SUCCESS: {
        const p = action.payload;
        if (p && typeof p === 'object' && !Array.isArray(p) && Array.isArray(p.rows)) {
          return {
            ...state,
            loading: false,
            reportingData: p.rows,
            reportingTotal: typeof p.total === 'number' ? p.total : 0,
            error: null,
          };
        }
        return {
          ...state,
          loading: false,
          reportingData: Array.isArray(p) ? p : [],
          reportingTotal: null,
          error: null,
        };
      }
      case FETCH_REPORTING_FAILURE:
        return {
          ...state,
          loading: false,
          reportingData: [],
          reportingTotal: null,
          error: action.payload,
        };
      case CLEAR_REPORTING_DATA:
        return {
          ...state,
          reportingData: [],
          reportingTotal: null,
        };

      default:
        return state;
    }
  };
  
  export default reportingReducer;
  